export const Permissions = {
  ACCESS_CLAIMS: 'access_claims',
  ACCESS_DOCUMENT_TEMPLATES: 'access_document_templates',
  ACCESS_ORDERS: 'access_orders',
  ACCESS_MAIL: 'access_mail',
  ACCESS_MEASUREMENT: 'access_measurement',
  ACCESS_MONTAGE: 'access_montage',
  ACCESS_HR: 'access_hr',
  ACCESS_LOGISTIC: 'access_logistic',
  ACCESS_ADMIN: 'access_admin',
  NOTIFY_MANUFACTURE_READY: 'notify_manufacture_ready',
} as const
